import * as yup from 'yup';
import { RiskTolerance } from '../../AccountOpening.meta';

export const riskToleranceOpts = [
  {
    label: 'Low',
    value: RiskTolerance.Low,
  },
  {
    label: 'Medium',
    value: RiskTolerance.Medium,
  },
  {
    label: 'High',
    value: RiskTolerance.High,
  },
];

export const riskToleranceValidation = yup
  .number()
  .nullable()
  .required('You need to specify your risk tolerance');
